import {
    WorkflowLayouts,
    WorkflowLayoutsStore,
} from '@servicetitan/financing-application-workflow-shared';
import { PropsWithChildren } from 'react';
import { FinalStepLayout } from '../features/layout/FinalStepLayout';

// In technician-application, these layouts are pretty much NOOPs.
const workflowLayouts: WorkflowLayouts = {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    DefaultLayout: ({ children }: PropsWithChildren) => <>{children}</>,
    FinalStepLayout,
};

export const WorkflowLayoutsProvider = ({ children }: PropsWithChildren) => {
    return (
        <WorkflowLayoutsStore.Provider initialState={workflowLayouts}>
            {children}
        </WorkflowLayoutsStore.Provider>
    );
};
